import './Table.css'

import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import TableRow from './TableRow'

class Table extends Component {
  constructor(props) {
    super(props)

    const defaultSortBy = (props.columns || []).find(({ isDefaultSort }) => isDefaultSort)

    this.state = {
      sortBy: (defaultSortBy && defaultSortBy.key) || null,
      reverse: false,
    }
  }

  renderTableHeaded = data => {
    const { reverse, sortBy } = this.state
    const { ColumnRender, key, subtitle, title } = data
    const canBeSorted = key && this.props.data.some(row => row[key])
    const hasFieldData = sortBy === key && this.props.data.some(row => row[sortBy])
    const className = [
      `cell cell-${key}`,
      hasFieldData && 'is-active',
      hasFieldData && reverse && 'desc',
      canBeSorted && 'cursor-pointer',
    ]
      .filter(Boolean)
      .join(' ')

    return (
      <th className={className} key={key} onClick={this.onSort(key)}>
        {ColumnRender ? (
          <ColumnRender {...data} sortBy={sortBy} reverse={reverse} />
        ) : (
          <>
            <span className="title">{title}</span>
            <span className="subtitle">{subtitle}</span>
          </>
        )}
      </th>
    )
  }

  onSort = sortBy => () => {
    const isValidSortFieldName = sortBy && this.props.data.some(row => row[sortBy])

    if (isValidSortFieldName) {
      this.setState(state => ({
        sortBy,
        reverse: state.sortBy === sortBy ? !state.reverse : false,
      }))
    }
  }

  get sortedData() {
    const { data } = this.props
    const { reverse, sortBy } = this.state
    const isValidSortFieldName = sortBy && data.some(row => row[sortBy])

    return data.sort((dataA, dataB) => {
      if (!isValidSortFieldName) {
        return 0
      }

      const valueA = ((reverse ? dataB[sortBy] : dataA[sortBy]) || '').toUpperCase()
      const valueB = ((reverse ? dataA[sortBy] : dataB[sortBy]) || '').toUpperCase()

      return valueA.localeCompare(valueB)
    })
  }

  render() {
    const { columns, data, tableClassName, keyExtractor, onRowClick, selected } = this.props

    return (
      <table className={classNames('table', tableClassName)}>
        <thead className="header">
          <tr>{columns.map(this.renderTableHeaded)}</tr>
        </thead>
        <tbody className="body">
          {this.sortedData.map((row, index) => (
            <TableRow
              key={keyExtractor ? keyExtractor(data) : index}
              onRowClick={onRowClick}
              columns={columns}
              data={row}
              isSelected={selected && selected.length > 0 && selected.includes(index)}
            />
          ))}
        </tbody>
      </table>
    )
  }
}

Table.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      CellRender: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
      ColumnRender: PropTypes.func,
      key: PropTypes.string.isRequired,
      subtitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
      title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    }),
  ),
  data: PropTypes.arrayOf(PropTypes.object),
  keyExtractor: PropTypes.func,
  onRowClick: PropTypes.func,
  onSort: PropTypes.func,
  selected: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  tableClassName: PropTypes.string,
}

export default Table
